import {
    useFetchData,
    useParseRouteActions,
  } from "../../../helpers/GlobalHelper";
  import { GlobalConstants } from "../../constants/GlobalConstants";
  import LmsFormGenerator, { BCFormController } from "../ui/LmsFormGenerator";
  import { recalcReportFields } from "../ui/LmsSharedForms";
  import LmsTable from "../ui/LmsTable";
  import { IdProps } from "../../interfaces/Global";
  
  const MainTable = () => {
    const actionButtons = ["add", "remove", "export"];
    return (
      <LmsTable
        actionButtons={actionButtons}
        apiSuffix="/accounting/global-remittance-monthly"
        deleteSuffix="/accounting/global-remittance-monthly"
        sortable={["Buyer", "Seller"]}
        columnLabelsDictionary= {{ servicingFeeToClsii: "Servicing Fee To CLSII", toBcfallRemainingAmounts: "To BCF All Remaining Amounts", servicingFeeToClsiinotPaidIn2: "Servicing Fee To CLSII Not Paid In2"  }}
      />
    );
  };
  
  const editMonthlyRecalcReportFormFields = (myForm: BCFormController) => {
    myForm.addCenteredGroup([
      myForm.getLabelField("Borrowing Base Data Calculation is in progress", { position: "center", fieldLabelClassName: "ui red header" }),
    ]);

    myForm.addCenteredGroup([
      myForm.getDropdownField("LP", "/metadata/list-lp-organizations", { name: "lpOrganizationId", disabled: true }),
      myForm.getBlankField(),
    ]);

    myForm.addCenteredGroup([
      myForm.getInputField("Buyer", { required: true, disabled: true }),
      myForm.getInputField("Seller", { required: true, disabled: true }),
    ]);

    myForm.addCenteredGroup([
      myForm.getInputField("Servicer", { required: true, disabled: true }),
      myForm.getInputField("Custodian", { required: true, disabled: true }),
    ]);

    myForm.addCenteredGroup([
      myForm.getInputField("Diligence Agent", { required: true, disabled: true }),
      myForm.getInputField("Account Bank", { required: true, disabled: true }),
    ]);

    myForm.addDividerField();
    myForm.addCenteredGroup([
      myForm.getCalendarField("Payment Date", { required: true, disabled: true, width: 4 })
    ]);

    myForm.addCenteredGroup([
      myForm.getCalendarField("Period Start", { required: true, disabled: true }),
      myForm.getCalendarField("Period End", { required: true, disabled: true }),
    ]);

    myForm.addCenteredGroup([
      myForm.getCalendarField("Revolving Period End Date", { required: true, disabled: true }),
      myForm.getCalendarField("Amortization Period End Date", { required: true, disabled: true }),
    ]);

    myForm.addDividerField();
    myForm.addCenteredGroup([
      myForm.getInputField("Cash Balance In Cash Management Account", {
        required: true,
        wrapLabel:true
      }),

      myForm.getInputField("Cash Balance", { required: true, disabled: true }),
    ]);

    myForm.addCenteredGroup([
      myForm.getInputField("Interest Reserve Balance", { required: true, disabled: true }),
      myForm.getInputField("Fees To Custodian", { required: true, disabled: true }),
    ]);

    myForm.addCenteredGroup([
      myForm.getInputField("Servicing Fee To CLSII", { name: "servicingFeeToClsii", required: true, disabled: true }),
      myForm.getInputField("Servicing Fee", { required: true, disabled: true }),
    ]);

    myForm.addCenteredGroup([
      myForm.getInputField("Extraordinary Expenses", { required: true, disabled: true }),
      myForm.getInputField("Interest Due", { required: true, disabled: true }),
    ]);

    myForm.addCenteredGroup([
      myForm.getInputField("Interest Reserve", { required: true, disabled: true }),
      myForm.getInputField("Borrowing Base Deficiency", { required: true, disabled: true }),
    ]);

    myForm.addDividerField();
    myForm.addCenteredGroup([
        myForm.getInputField("Principal Due", { required: true, disabled: true }),
        myForm.getInputField("Buyer Costs Or Fees", { required: true, disabled: true }),
    ]);

    myForm.addCenteredGroup([
        myForm.getInputField("Servicing Fee To CLSII Not Paid In2", { name:"servicingFeeToClsiinotPaidIn2", required: true, disabled: true }),
        myForm.getInputField("Cash Waiting To Be Remaining", { required: true, disabled: true }),
    ]);

    myForm.addCenteredGroup([
        myForm.getInputField("To BCF All Remaining Amounts", { name:"toBcfallRemainingAmounts", required: true, disabled: true }),
        myForm.getInputField("Remaining Cash Balance", { required: true, disabled: true }),
    ]);

    myForm.addDividerField();
    myForm.addCenteredGroup([
        myForm.getDropdownField("Global Remittance Status", "/metadata/list-global-remittance-statuses", { name: "globalRemittanceStatusId", required: true, disabled: true }),
        myForm.getCalendarField("Payment Confirmation Received On", { disabled: true } )
    ]);

    myForm.addDividerField();
    myForm.addCenteredGroup([myForm.getCalendarField("Renewal Start Date", { disabled: true } ), myForm.getCalendarField("Renewal End Date", { disabled: true } )]);
    myForm.addCenteredGroup([myForm.getCalendarField("Servicing Confirmation Received On", { disabled: true }), myForm.getBlankField()]);
    return myForm;
  };
  
  const EditAccountingWeeklyRecalcReportForm = ({ id }: IdProps) => {
    const [{ data = {}, isLoading, error }] = useFetchData(`/accounting/global-remittance-monthly/${id}`);
    const myForm = editMonthlyRecalcReportFormFields(
      new BCFormController(data, { submitSuffix: "/accounting/global-remittance-monthly", blankWidth: 2 })
    );
  
    const formActions = ["close"];
    return (
      <LmsFormGenerator
        myForm={myForm}
        isLoading={isLoading}
        error={error}
        actions={formActions}
      />
    );
  };

  const AddAccountingWeeklyRecalcReportForm = () => {
    const [{ data = {}, isLoading, error}] = useFetchData("/accounting/global-remittance-monthly-initial-data");
    const myForm = new BCFormController(data, {submitSuffix: "accounting/global-remittance-monthly", blankWidth: 5, submitMethod: "POST" });
    recalcReportFields(myForm, false);  
    const formActions = [{ 
      text: "Get Borrowing Base Data",
       icon: GlobalConstants.Icons.SAVE,
       action: "save-close",
      }, "close"];

    return (<LmsFormGenerator 
      myForm={myForm} 
      actions={formActions} 
      isLoading={isLoading}  
      error={error} 
      submitConfirmationMessage="Borrowing Base data calculation will take some time. We will inform you by email."
    />);
  };
  
  const LmsAccountingMonthlyRecalcReport = ({
    params = {},
    history,
  }) => {
    const { isMainPage, isAdd, isEdit, isActionAllowed, id } =
      useParseRouteActions(params);
    if (!isActionAllowed) {
      history.goBack();
    }
  
    return (
      <>
        {isMainPage && <MainTable />}
        {isAdd && <AddAccountingWeeklyRecalcReportForm />}
        {isEdit && <EditAccountingWeeklyRecalcReportForm id={id} />}
      </>
    );
  };
  
  export default LmsAccountingMonthlyRecalcReport;